export default {
  refreshStageQuantity: 'loadSimulation.refreshStageQuantity',
};
